var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "xv3lo98opa",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#xv3lo98opa)",
    transform: "translate(-1089.000000, -152.000000) translate(1040.000000, 0.000000) translate(40.000000, 143.000000) translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M12.449 8.14c-.311-.131-.673.006-.808.308-.85 1.889-2.77 3.11-4.89 3.11-1.682 0-3.237-.768-4.233-2.028l2.096.405c.332.065.655-.145.722-.468.066-.323-.15-.637-.483-.701l-3.436-.664c-.332-.064-.655.145-.722.468l-.683 3.34c-.066.322.15.636.482.7.04.008.08.012.12.012.287 0 .544-.197.602-.48l.374-1.828c1.226 1.515 3.117 2.436 5.16 2.436 2.61 0 4.97-1.501 6.015-3.825.136-.301-.006-.653-.316-.785zM13.006.14c-.332-.065-.655.145-.722.468l-.374 1.828C10.684.921 8.793 0 6.75 0 4.141 0 1.78 1.501.735 3.825c-.136.301.006.653.317.785.08.034.163.05.245.05.236 0 .462-.134.563-.358.85-1.889 2.769-3.11 4.89-3.11 1.681 0 3.236.768 4.232 2.027l-2.096-.405c-.333-.064-.656.146-.722.469-.066.323.15.636.482.7l3.437.665c.04.008.08.011.12.011.12 0 .239-.034.34-.1.136-.088.23-.224.262-.38L13.488.84c.066-.322-.15-.636-.482-.7z",
    transform: "translate(2.250000, 3.000000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadWhite);
export default __webpack_public_path__ + "static/media/reload-white.6ecb9301159fbc5a49be4c2d7e144d62.svg";
export { ForwardRef as ReactComponent };